import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import JsonData from "../data/data.json";

export const About = () => {
  const { t } = useTranslation("landing");
  const { t: tCommon } = useTranslation("common");
  const aboutRef = useRef(null);
  const brand = JsonData?.About?.nameBank || "CIRYON";
  const paragraphs = t("about.paragraphs", { returnObjects: true });

  useEffect(() => {
    const section = aboutRef.current;
    if (!section) return;

    const reveal = () => section.classList.add("is-visible");

    // Sem IO ou com movimento reduzido, o conteúdo simplesmente aparece.
    if (
      !("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      reveal();
      return;
    }

    // Só escondemos depois de garantir que existe quem revele.
    section.classList.add("js-reveal");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          reveal();
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={aboutRef}>
      <div className="container">
        <div className="about__grid">
          <div className="about__text">
            <h2>{t("about.title", { brand })}</h2>

            <p className="about__slogan">{tCommon("slogan")}</p>

            {Array.isArray(paragraphs) ? (
              paragraphs.map((paragraph, index) => (
                <p className="paragraph" key={index}>
                  {paragraph}
                </p>
              ))
            ) : (
              <p className="paragraph">{t("about.loading")}</p>
            )}
          </div>

          <div className="about__media">
            <img
              src="img/bout.png"
              className="about__image"
              alt=""
              aria-hidden="true"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
